'use es6';

import { PUBLISHED_PAGE, SENT_EMAIL, BLOG_POST_TEMPLATE, BLOG_LISTING_TEMPLATE, SYSTEM_TEMPLATE, CONTENT_SETTINGS, QUOTE_TEMPLATE, SALES_QUOTE_TEMPLATE } from 'DesignData/constants/CosIndexConnectionCategories';
export default Object.freeze([PUBLISHED_PAGE, SENT_EMAIL, BLOG_POST_TEMPLATE, BLOG_LISTING_TEMPLATE, SYSTEM_TEMPLATE, CONTENT_SETTINGS, QUOTE_TEMPLATE, SALES_QUOTE_TEMPLATE]);